/* eslint-disable import/prefer-default-export */
import React, { useContext, useState } from 'react';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { showContextMenu } from 'store/Manage/actions';
import { useIntl } from 'react-intl';
import {
  FEATURE_CREDENTIALS, PERMISSION_TYPES
} from 'Hooks/usePermission/permissions';
import { WithPermission } from 'Common/Components/WithPermission';
import { ThemeContext } from 'Context';
import { DeleteIcon } from 'Screens/Contextualization/Manage/components/ManageTable/components/ContextMenu/components/styled';
import { showCredentialModalDelete } from 'store/Credentials/actions';
import { selectCredentialsSelected } from 'store/Credentials/selectors';
import ModalWarning from 'Common/Components/ModalWarning';

export const Delete = () => {
  const dispatch = useDispatch();
  const title = useIntl().formatMessage({ id: 'manage.cm.delete' });
  const { themeStyles } = useContext(ThemeContext);
  const intl = useIntl();
  const [showWarning, setShowWarning] = useState(false);
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const message = intl.formatMessage(
    { id: 'modalWarning.selectOneOrMore' },
    { entity: 'Credential' }
  );

  const handleClick = () => {
    if (credentialsSelected.length > 0) dispatch(showCredentialModalDelete(true));
    else setShowWarning(true);
    dispatch(showContextMenu(false));
  };

  const onClose = () => setShowWarning(false);

  return (
    <>
      <WithPermission permission={ FEATURE_CREDENTIALS } type={ PERMISSION_TYPES.DELETE }>
        <MenuItem
          title={ title }
          color={ themeStyles.text.contextMenuDelete }
          icon={ <DeleteIcon /> }
          onClick={ handleClick }
        />
      </WithPermission>
      {showWarning && (
        <ModalWarning
          onCloseCallback={ onClose }
          title="Delete Credential"
          description={ message }
        />
      )}
    </>
  );
};
